import ClientLocaleProvider from "@edaz/services/clientLocaleProvider";
import type { LocaleCode } from "@edaz/services/baseLocaleProvider";
import { bound } from "@frui.ts/helpers/dist";
import { observable } from "mobx";
import EventBus, { localeChanged } from "./eventBus";

export default class LocaleProvider extends ClientLocaleProvider {
  @observable locale: LocaleCode;

  constructor(private eventBus: EventBus) {
    super();
  }

  @bound
  changeLocale(locale: string): boolean {
    const status = super.changeLocale(locale);

    if (status) {
      this.eventBus.publish(localeChanged({ locale }));
    }

    return status;
  }
}
